import { doPostFetch } from "./apiFetchHelper";
const url = `/api/log`;

export function logMessage(message, type = null) {
  const data = { message: message };
  if (type) data.type = type;
  return doPostFetch(url, data);
}

export default {
  logMessage,
};
